import type {FC} from 'react';
import React from 'react';
import clsx from 'clsx';

import type {KeyedArray} from '@/modules/foundation/shared/types';
import type {ContentBlockContainerProps} from '@/modules/page/components/content-blocks/block-container';
import {ContentBlockContainer} from '@/modules/page/components/content-blocks/block-container';

import type {LinkCardProps} from './LinkCard';
import LinkCard from './LinkCard';

interface Props extends ContentBlockContainerProps {
	links?: KeyedArray<LinkCardProps>;
	insideToc?: boolean;
}

export const CardLinkListSelection: FC<Props> = ({links, options, insideToc}) => {
	return (
		<ContentBlockContainer options={options} insideToc={insideToc}>
			<div className="@container">
				<ul
					className={clsx(
						'grid',
						'gap-4',
						'@3xl:gap-10',
						'grid-cols-1',
						links?.length === 2 ? '@3xl:grid-cols-2' : '@3xl:grid-cols-3',
						'justify-start',
						'content-start',
					)}
				>
					{links?.map((link) => (
						<li key={link._key}>
							<LinkCard {...link} />
						</li>
					))}
				</ul>
			</div>
		</ContentBlockContainer>
	);
};
